import { Input, Modal } from "antd";
import React,{useState} from "react";
import styles from "./index.module.scss";

function FreequancyCustomisationModal({
  freequancyList,
  isOpen,
  handleClose,
  addFreequancy,
  removeFreequancy,
  onChangeData,
  onSave,
}) {
  const [isEnabled, setIsEnabled] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {

    const allValuesMeetCondition = freequancyList.every(value => Boolean(value));
    console.info("allValuesMeetCondition",allValuesMeetCondition)

    if(allValuesMeetCondition)
    {
      setIsEnabled(false)
    }else
    {
      setIsEnabled(false)
    }
   
   
  };
  
  return (
    <Modal
      footer={false}
      closeIcon={<></>}
      className={styles.modal_container}
      open={isOpen}
      onCancel={handleClose}
      backdrop="static"
      maskClosable={false}
    >
      <div className={styles.freequanct_inout_wrap}>
        <h6>Custom Frequency</h6>
        {freequancyList.map((eachFreequancy, key) => {
          return (
            <div className={styles.freequanct_inout_wrap_1} style={{width:"100%"}}>
            <div className={styles.freequanct_inout_wrap_2}>
              <Input
                value={eachFreequancy}
                onChange={(e) => {
                  //handleInputChange(e)
                  onChangeData({ key, value: e?.target?.value });
                 
                }}
                className={styles.freequancy_input}
                key={key}
                onKeyUp={(e) => handleInputChange({ key, value: e?.target?.value })}
                maxLength={5}
                type="text"
                name=""
                id=""
              />
              {/* <i class="fas fa-trash fa-xs"></i> */}
              
            </div>
            <div className={styles.seperator} ><i>-</i></div>
            </div>
            
          );
        })}
        <button className={styles.add_btn} onClick={addFreequancy}>
          Add more +
        </button>
      </div>

      <div className={styles.footer}>
        <button onClick={handleClose} className={styles.cancel_btn}>
          Cancel
        </button>

        <button onClick={onSave} className={styles.save_btn} disabled={isEnabled}>
          Save
        </button>
      </div>
    </Modal>
  );
}

export default FreequancyCustomisationModal;
